import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import Checkbox from 'material-ui/Checkbox';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import PanoramaFishEye from 'material-ui/svg-icons/image/panorama-fish-eye';

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'

import { dirtyRead, doc } from 'selectors/common'
import { properties, tenants} from 'selectors/entities'
import { projectTasks } from 'selectors/tasks'

import dataActions from 'actions/dataActions'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	})
)

export class TaskCard extends Component {
	render(){
		let { props } = this
		let doneTask = props.task && props.task.status == "0closed"
		let urgent = props.task && props.task.status == "1urgent"
		let dependencies=props.object && props.object.dependencies || []
		////console.log(dependencies);
		return(
			(!props.task)?
				<div></div>
				:
				<ListItem
					style={{
						overflow: 'hidden'
					  , paddingLeft: "0"
					  , marginLeft: "0"
					  , margin: "0"
					  , textOverflow: "ellipsis"
					  , fontSize: "16px"
					}}
					innerDivStyle={{
						padding: "0 15px"
					}}
					className="list-hover"
				>
					<Link
						className="task-card"
						to={`/landlord/task/${props.task._id}`}
						style={{
							textDecoration: 'none'
						  , position: "relative"
						  , zIndex: "1000"
						  , display: "inline-block"
						  , justifyContent: "space-between"
						  , width: "80%"
						  , padding: "15px 0"
						  , paddingLeft: "0px"
						}}
						key={props.task._id}
					>
					<div style={{display:"inline-block", float:"left", position:"relative", left:"-20px", width:"20px"}}>
						{/*<TaskStatusIcon status={props.task.status} />*/}
					</div>
						<p
							style={{
								margin:"0"
							  , paddingTop: "5px"
							  , textDecoration: (doneTask)?"line-through": "none"
							  , color: (urgent)? "#fd9a41": "black"
							}}
						>
							{(props.task.taskContent)? props.task.taskContent: "No task content"}
						</p>
					</Link>
					<Checkbox
						label=""
						labelStyle={{
							color: "black"
						  , fontSize: "16px"
						  , fontWeight: "bold"
						}}
						iconStyle={{
							fill: "black"
						}}
						style={{
							marginLeft: "-1px"
						  , width:"10%"
						  , marginTop:"15px"
						  , float: "right"
						}}
						checked={R.indexOf(props.task._id,dependencies)!=-1}
						disabled={true}
						onCheck={() =>{
							let newDependencies = dependencies
							let index = R.indexOf(props.task._id,dependencies)
							if(index==-1){
								newDependencies.push(props.task._id)
							}else{
							newDependencies=[
								...newDependencies.slice(0,index)
						      , ...newDependencies.slice(index+1)
							]
							}
							props.DOC_UPDATE({
								_id: props.objectID
							  , dependencies: newDependencies
							})}
						}
					/>
				</ListItem>
		)
	}
}
export default connect(select, dataActions)(TaskCard)



// WEBPACK FOOTER //
// ./src/routes/landlord/taskForm/TaskCard.js